function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    color: ",
        ";\n    height: ",
        ";\n    width: ",
        ";\n    display: flex;\n    flex-shrink: 0;\n    transition: color 50ms ease;\n\n    svg {\n        height: 100%;\n        width: 100%;\n    }\n\n    &:disabled {\n        color: ",
        ";\n    }\n\n    &:not(:disabled) {\n        ",
        "\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { rem } from "polished";
import CloseIcon from "../svg/close.svg";
import { Base } from "../palette/base";
import { hover } from "../css/hover";
export var MiniCloseButton = function(props) {
    return /*#__PURE__*/ _jsx(Container, _objectSpread({}, props, {
        children: /*#__PURE__*/ _jsx(CloseIcon, {})
    }));
};
var Container = styled.button.withConfig({
    componentId: "sc-f77b0c3d-0"
})(_templateObject(), Base.Primary100, rem(20), rem(20), Base.Primary200, hover("color: ".concat(Base.Primary200, ";")));
